import { init } from "./init";

// Exportação oficial do módulo (uso via import / require)
export { init } from "./init";
export { UTMSInit } from "./utils/paramsTracker";
export type { InitProps, ParamsTrackerContext } from "./types";

// Exportações das funções utilitárias
export { waitForFirstUserInteraction } from "./utils/waitForFirstUserInteraction";
export { log } from "./utils/log";

function autoInitFromScriptTag() {
  if (typeof window !== "undefined" && typeof document !== "undefined") {
    const scriptTag = document.currentScript as HTMLScriptElement | null;

    if (scriptTag) {
      const enabled = scriptTag.getAttribute("data-enabled") !== "false";
      const delay = parseInt(scriptTag.getAttribute("data-delay") || "0", 10);
      const debug = scriptTag.getAttribute("data-debug") === "true";

      init({
        enabled,
        delay,
        debug,
      });
    }
  }
}

autoInitFromScriptTag();
